import { BOT_TYPE_TO_DISPLAY_NAME } from "@shared/features/bots/constants";
import Flex from "common/Boxes/Flex";
import EmptyView from "common/Empty/EmptyView";
import { StylableButton } from "common/Buttons/Button";
import { getBotFormRoute } from "utils/routes";
import { BotFormType } from "@shared/features/bots/BotForm/common/types";
import React, { MouseEvent } from "react";
import styled, { useTheme } from "styled-components";
import { useHistory } from "react-router-dom";
import { BotType, LanguageNameSpaces } from "@shared/types";
import { EmptyStatesType } from "common/Icons/types.ts";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface BotsCardEmptyProps {
  botType: BotType;
}

const BotsCardEmpty = ({ botType }: BotsCardEmptyProps) => {
  const theme = useTheme();
  const history = useHistory();
  const { t } = useTypedTranslation(LanguageNameSpaces.DASHBOARD);
  const { t: tBots } = useTypedTranslation(LanguageNameSpaces.BOTS);
  const botDisplayName = tBots(BOT_TYPE_TO_DISPLAY_NAME[botType]);

  const onCreateClick = (e: MouseEvent) => {
    e.stopPropagation();
    history.push(getBotFormRoute(botType, BotFormType.CREATE));
  };

  return (
    <Flex $flexDirection="column">
      <EmptyView
        iconKey={EmptyStatesType.Bots}
        description={t("bots.empty_description", { botDisplayName })}
        iconWidth={100}
        descriptionStyle={{ fontSize: theme.typography.fontSizes.S }}
        style={{ paddingBottom: 12, paddingTop: 0 }}
      />
      <CreateButton onClick={onCreateClick}>
        {t("bots.empty_create_button", { botDisplayName })}
      </CreateButton>
    </Flex>
  );
};

export default BotsCardEmpty;

const CreateButton = styled(StylableButton).attrs({ type: "primary" })`
  width: 100%;
`;
